const url = 'https://conwy-fleet.gwynedd.llyw.cymru/';

export const environment = {
  production: true,
  gwreiddynCleient: url,
  apiUrl: `${url}api`,
  hunaniaethCyfeiriad: `${url}mynediad/`,
  hunaniaethIdCleient: 'di-enw-client',
  hunaniaethScope: 'openid di-enw-api email profile roles offline_access',
  hunaniaethResponseType: 'code',
  // paginator
  paginator: {
    pageIndex: 0,
    pageSize: 25,
    pageSizeOptions: [5, 10, 25, 100]
  },
  paginatorCartref: {
    pageIndex: 0,
    pageSize: 5,
    pageSizeOptions: [5]
  },
  flex: {
    fxLayout: 'row',
    fxLayoutAlign: 'end',
    fxLayoutGap: '20px'
  },
  // Ieithoedd
  iaith: {
    cymraeg: 'cy',
    saesneg: 'en',
    rhifIaithCymraeg: 1,
    rhifIaithSaesneg: 2,
  }
};
